import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { INewClientAccountModel } from '@apps-common/types/portal/client-account'

export const addMyMonitoringUser = async (model: INewClientAccountModel): Promise<boolean> =>
  axios.post(`/my-monitoring/sites/AddMyMonitoringUser`, model).then((res) => res?.data?.result)

type Props = {
  model: INewClientAccountModel
}

export const useMyMonitoringAddMyMonitoringUser = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['addMonitoringUser'],
    mutationFn: ({ model }: Props) => addMyMonitoringUser(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Added myMonitoring user.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to add myMonitoring user.')
      }
    },
    throwOnError: false
  })
